import { securityTips } from "@/mocks/home";

export default function SecuritySection() {
  return (
    <section id="security" className="border-t border-background-200 bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">
            安全提示
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            找地址时如何避开仿冒站点
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            地址经常变化，也给仿冒站留下了可乘之机。下面几条习惯可以帮你在找官网、
            换地址、下载App的过程中少踩坑。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {securityTips.map((tip) => (
            <div
              key={tip.title}
              className="flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${tip.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base text-foreground-950">{tip.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{tip.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-4 rounded-2xl border border-primary-200 bg-primary-50 p-6 md:flex-row md:items-center md:justify-between md:p-8">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-bookmark-3-line text-2xl" aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-lg text-foreground-950">把本页设为长期书签</h3>
              <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-foreground-700">
                本页是地址变化时最省心的入口索引。收藏之后，无论域名怎么轮换，
                都能从这里找回当前收录的官网、最新地址与下载入口。
              </p>
            </div>
          </div>
          <a
            href="#address"
            className="inline-flex w-fit items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-up-line text-base" aria-hidden="true"></i>
            回到最新地址
          </a>
        </div>
      </div>
    </section>
  );
}